import React from 'react';
import './AnimatedArrow.css';

export const AnimatedArrow = ({ className = '' }) => {
  return (
    <div className={`animated-arrow-container ${className}`}>
      <svg 
        width="40" 
        height="40" 
        viewBox="0 0 40 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="animated-arrow-svg"
      >
        <path 
          d="M15 10L25 20L15 30" 
          stroke="#264F77" 
          strokeWidth="3" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          className="arrow-path"
        />
      </svg>
    </div>
  );
};
